import React from 'react'

import classnames from 'classnames'
import PropTypes from 'prop-types'

import { StyledToggleButton } from './ToggleButton.styles'

export const ToggleButton = ({
  children,
  baseCN,
  className,
  disabled,
  selected,
  'data-mu-test': dataAttributeTest,
  onClick,
  padding,
  ...props
}) => {
  return (
    <StyledToggleButton
      className={classnames(
        baseCN,
        {
          [`${baseCN}--selected`]: selected,
          [`${baseCN}--disabled`]: disabled
        },
        className
      )}
      data-mu-test={dataAttributeTest}
      $selected={selected}
      $padding={padding}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledToggleButton>
  )
}

ToggleButton.defaultProps = {
  disabled: false,
  selected: false,
  padding: '0 16px',
  baseCN: 'e-toggle-btn'
}

ToggleButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  baseCN: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  padding: PropTypes.string,
  'data-mu-test': PropTypes.string,
  onClick: PropTypes.func
}
